import $ from 'jquery';

$(document).ready(function () {
  twoColumnBlock();
});
function twoColumnBlock() {
  $('.js-acf-two-column-block').each(function () {});
}
